import React from "react";
import "./navbar.css";

const Navbar = () => {
  return (
    <header className="navbar">
      <span className="navLogo">Luka.B</span>
      <nav className="navLinks">
        <a href="#about">
          About <span>01</span>
        </a>
        <a href="#projects">
          Projets <span>02</span>
        </a>
        <a href="mailto:brouar_l@etna-alternance.net">
          Contact <span>03</span>
        </a>
      </nav>
    </header>
  );
};

export default Navbar;
